import React, { useEffect, useMemo, useState } from "react";
import {
  useAdminManageWeekly,
  useMyTeam,
} from "../modules/manage_weekly-schedule/store/index";
import { useLocation, useNavigate } from "react-router-dom";
import NoData from "assets/svgs/no_data/NoData";
import {
  adminRole,
  fourPlaceHolder,
  getCurrentUserRole,
} from "modules/utilities/utility";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import AdvanceTableSearchBox from "modules/common/advance-table/AdvanceTableSearchBox";
import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "modules/common/advance-table/AdvanceTablePagination";
import { Tooltip } from "antd";
import { Card, Col, Row } from "react-bootstrap";
import classNames from "classnames";

function ManageWeekly() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sd = searchParams.get("sd");
  const ed = searchParams.get("ed");
  const id = searchParams.get("id");
  const { teamData, teamLoading, fetchMyTeamData } = useMyTeam();
  const {
    medRepData,
    supportData,
    medExtData,
    leadData,
    weeklyLoading,
    fetchMedicalRepData,
    fetchMedicalExtData,
    fetchSupportData,
    fetchLeadData,
  } = useAdminManageWeekly();
  const [team, setTeam] = useState();
  useEffect(() => {
    if (adminRole.includes(getCurrentUserRole())) {
      fetchMedicalRepData("medical_rep");
      fetchMedicalExtData("medrep_ext");
      fetchSupportData("support");
      fetchLeadData("lead_agent");
    } else {
      fetchMyTeamData();
    }
  }, []);

  useEffect(() => {
    if (adminRole.includes(getCurrentUserRole())) {
      if (medRepData?.userRole) {
        setTeam([
          ...(medRepData?.userRole || []),
          ...(supportData?.userRole || []),
          ...(medExtData?.userRole || []),
          ...(leadData?.userRole || []),
        ]);
      }
    } else {
      if (teamData) {
        setTeam(teamData?.userGroup);
      }
    }
  }, [teamData, medRepData, supportData, medExtData]);

  const loading = adminRole.includes(getCurrentUserRole())
    ? weeklyLoading
    : teamLoading;

  const tableData = useMemo(() => {
    return team?.map((item) => {
      return {
        is_active: item.user.is_active ? "Active" : "Inactive",
        name: item.user.first_name,
        phone_number: item.user.phone_number,
        email: item.user.email,
        alternate_email: item.user.alternate_email,
        id: item.user.id,
      };
    });
  }, [team]);

  const columns = [
    {
      accessor: "name",
      Header: "First Name",
      headerProps: { className: "text-900" },
      Cell: ({ row }) => (
        <div
          className="cursor-pointer text-primary"
          onClick={() => {
            navigate(
              `/medRep-engagement?id=${row.original.id}&sd=${sd}&ed=${ed}`
            );
          }}
        >
          <Tooltip title="Click to navigate">{row.original.name}</Tooltip>
        </div>
      ),
    },
    {
      accessor: "phone_number",
      Header: "Phone Number",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "email",
      Header: "Email",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "alternate_email",
      Header: "Alternate Email",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "is_active",
      Header: "Active Status",
      headerProps: { className: "text-900" },
    },
  ];

  return (
    <Card className={"text-bg-white"}>
      <Card.Body>
        <Card.Title
          as="div"
          className={`${classNames({
            "text-black": "Light",
          })} border-bottom pb-2 fs-1 ps-2`}
        >
          Manage Weekly
        </Card.Title>
        <Card.Text>
          <div className="h-100 card p-2 shadow-md">
            {loading ? (
              fourPlaceHolder()
            ) : tableData?.length ? (
              <AdvanceTableWrapper
                columns={columns}
                data={tableData}
                sortable
                pagination
                perPage={10}
              >
                <Row className="flex-end-center mb-3">
                  <Col xs="auto" sm={6} lg={4}>
                    <AdvanceTableSearchBox
                      table
                      placeholder="Name Email or Phone Number"
                    />
                  </Col>
                </Row>
                <AdvanceTable
                  table
                  headerClassName="bg-200 text-nowrap align-middle"
                  rowClassName="align-middle white-space-nowrap"
                  tableProps={{
                    bordered: true,
                    striped: true,
                    className: "fs-10 mb-0 overflow-hidden",
                  }}
                />
                <div className="mt-3">
                  <AdvanceTablePagination table className="pagination-sm" />
                </div>
              </AdvanceTableWrapper>
            ) : (
              <div className="d-flex p-2 justify-content-between border rounded">
                Data is not available <NoData />{" "}
              </div>
            )}
          </div>
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default ManageWeekly;
